import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { deleteUsers } from '../../../stores/users/actionCreators';
import { getUserName } from '../../../stores/users/selectors';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    getName: (id: string) => string;
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];

    deleteUsers: (ids: string[]) => void;
}
interface State {
    showModal: boolean;
}

class DeleteUsersAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['DELETE_USER', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="danger"
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'trash']} />
                        {t('users.button.delete')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('users.modal.delete.header') as string}
                        confirmText={t('users.modal.delete.delete') as string}
                        buttonColor="danger"
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.props.deleteUsers(this.props.selected);
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('users.modal.delete.text') as string} <b>{this.getHandle()}</b>?
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private getHandle = () => {
        const t = this.props.translate;
        if (this.props.selected.length !== 1) {
            return t(
                'users.modal.delete.users',
                { number: this.props.selected.length }
            );
        } else {
            return this.props.getName(this.props.selected[0]);
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    getName: getUserName(state),
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'users'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    deleteUsers: (ids: string[]) => dispatch(deleteUsers(ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(DeleteUsersAction));